var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-layout-modal',{staticClass:"w-page-error",class:{
    'w-page-error--mobile': _vm.$vuetify.breakpoint.smAndDown,
  },attrs:{"props":{
    flat: true,
    tile: true,
  },"no-title":""},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('p',{staticClass:"body-2"},[_vm._v("\n      "+_vm._s(_vm.explain)+"\n    ")])]},proxy:true},{key:"actions",fn:function(){return [_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","depressed":"","nuxt":"","to":"/"}},[_vm._v("\n      "+_vm._s(_vm.$t('home'))+"\n    ")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }